const downloadDisclosure = jsonString => {
    try {
        const obj = JSON.parse(jsonString);
        if (obj.url) {
            window.open(obj.url);
        }
    } catch (e) {
        console.log(e);
    }
};

export default downloadDisclosure;
